export default "__VITE_ASSET__DYMEBGWk__"